import Token from "../Token.js";
import { TOKEN_TYPE } from "../TokenType.js";

export default class UndefinedToken extends Token
{
    constructor() {
        super( TOKEN_TYPE.UNDEFINED, null );
    }
}